import SimpleUrlInput from "./SimpleUrlInput";
import { displayUrl } from "../utils/urlForm";

/** Full-width card URL row — same pattern as PageSpeed / logged-in SEO Audit. */
export default function ToolUrlCard({
  url,
  onChange,
  onSubmit,
  buttonLabel = "Run",
  loading = false,
  disabled = false,
  placeholder = "your-website.com",
  className = "",
  inputAriaLabel = "Website URL",
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!disabled && !loading && displayUrl(url)) onSubmit?.();
  };

  return (
    <div className={`card tool-url-card ${className}`.trim()}>
      <form className="tool-url-form" onSubmit={handleSubmit}>
        <SimpleUrlInput
          value={url}
          onChange={onChange}
          disabled={disabled || loading}
          placeholder={placeholder}
          aria-label={inputAriaLabel}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !loading && !disabled && displayUrl(url)) {
              onSubmit?.();
            }
          }}
        />
        <button
          type="submit"
          className="btn btn-primary tool-url-submit"
          disabled={disabled || loading || !displayUrl(url)}
        >
          {loading ? "Please wait..." : buttonLabel}
        </button>
      </form>
    </div>
  );
}
